export enum AppMarketPage {
  MANAGE_APPS = 'manage-apps',
  APP_PAGE = 'app_page',
  CATEGORY = 'category',
  SUB_CATEGORY = 'sub-category',
  COLLECTION = 'collection',
  HOMEPAGE = 'homepage',
  SEARCH_RESULT = 'search-result',
  DEVELOPER = 'developer-page',
  FOR_YOU = 'for-you',
  TOOLS = 'tools',
  AI_AGENTS = 'ai-agents',
}

export enum inContextAppSectionType {
  SECTION = 'section',
  COLLECTION = 'collection',
}
